import { useFavoriteModel } from './favorite.model'
import type { IFavoriteProps } from './favorite.types'
import { FavoriteView } from './favorite.view'

export const Favorite = (props: IFavoriteProps) => {
  const favoriteModel = useFavoriteModel(props)
  return <FavoriteView {...favoriteModel} size={props.size || 'md'} />
}
